// extracted by css-extract-rspack-plugin
export default {"removeLinkAnchor":"ma0fi","embedCodeContainer":"A30QR","copyButtonContainer":"VymgX","embedCode":"pLs75"};